(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bigiti-product-confidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const section = document.querySelector('.bigiti-product-upgrade');
      const trust = section?.querySelector('[data-bigiti-trust]');
      const anchor = section?.querySelector('[data-bigiti-trust-anchor]');
      const aboutCta = section?.querySelector('[data-bigiti-about-cta]');
      const aboutLink = section?.querySelector('[data-bigiti-about-link]');
      const aboutContent = section?.querySelector('.bigiti-product-upgrade__content');
      const productPanel = document.querySelector('.product-information .product-details > .group-block') || document.querySelector('.product-information .product-details');
      const productPanelContent = productPanel?.querySelector('.group-block-content') || productPanel;
      const productMain = document.querySelector('.product-information');

      if (!section || !trust || !anchor || !aboutCta || !aboutContent || !productPanel || !productPanelContent || !productMain || section.dataset.trustReady === 'true') return;
      section.dataset.trustReady = 'true';

      const panelSlot = document.createElement('div');
      panelSlot.className = 'bigiti-product-upgrade__panel-slot';
      productPanelContent.appendChild(panelSlot);

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

      const moveTrust = (destination, inPanel) => {
        if (trust.parentElement === destination) return;
        const first = trust.getBoundingClientRect();
        destination.appendChild(trust);
        trust.classList.toggle('is-product-panel', inPanel);
        const last = trust.getBoundingClientRect();

        if (!isMobile() && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          trust.animate([
            { transform: `translate(${first.left - last.left}px, ${first.top - last.top}px) scale(.97)`, opacity: .55 },
            { transform: 'translate(0, 0) scale(1)', opacity: 1 }
          ], { duration: 520, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
      };

      let ticking = false;
      const update = () => {
        ticking = false;

        if (isMobile()) {
          moveTrust(panelSlot, true);
          return;
        }

        const anchorTop = anchor.getBoundingClientRect().top;
        const mainBottom = productMain.getBoundingClientRect().bottom;
        const shouldShowBelow = anchorTop < window.innerHeight * .86 || mainBottom < window.innerHeight * .58;
        moveTrust(shouldShowBelow ? anchor : panelSlot, !shouldShowBelow);
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      panelSlot.appendChild(aboutCta);
      moveTrust(panelSlot, true);

      aboutLink?.addEventListener('click', (event) => {
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const startPosition = window.scrollY;
        const destination = startPosition + aboutContent.getBoundingClientRect().top - 110;

        if (reducedMotion) {
          window.scrollTo(0, destination);
          return;
        }

        const duration = 800;
        const startTime = performance.now();
        const animateScroll = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 4);
          window.scrollTo(0, startPosition + (destination - startPosition) * easedProgress);
          if (progress < 1) window.requestAnimationFrame(animateScroll);
        };
        window.requestAnimationFrame(animateScroll);
      });

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      update();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
